var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruck1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 79,
    viewBox: "0 0 80 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 52.6666C14.2545 52.6666 10.6665 56.2546 10.6665 60.6666C10.6665 65.0787 14.2545 68.6666 18.6665 68.6666C23.0785 68.6666 26.6665 65.0787 26.6665 60.6666C26.6665 56.2546 23.0784 52.6666 18.6665 52.6666ZM18.6665 65.9999C15.7251 65.9999 13.3332 63.6079 13.3332 60.6666C13.3332 57.7252 15.7253 55.3333 18.6665 55.3333C21.6078 55.3333 23.9998 57.7254 23.9998 60.6666C23.9998 63.6079 21.6078 65.9999 18.6665 65.9999Z",
    fill: "#007F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 52.6666C59.588 52.6666 56 56.2546 56 60.6666C56 65.0787 59.588 68.6666 64 68.6666C68.412 68.6666 72 65.0787 72 60.6666C72 56.2546 68.412 52.6666 64 52.6666ZM64 65.9999C61.0586 65.9999 58.6667 63.6079 58.6667 60.6666C58.6667 57.7252 61.0588 55.3333 64 55.3333C66.9414 55.3333 69.3333 57.7254 69.3333 60.6666C69.3333 63.6079 66.9414 65.9999 64 65.9999Z",
    fill: "#007F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7882 45.2788L67.7882 26.612C67.5429 26.2306 67.1203 26 66.6668 26H52.0003C51.2629 26 50.667 26.5973 50.667 27.3333V60.6666C50.667 61.4039 51.2629 61.9998 52.0003 61.9998H57.3336V59.3331H53.3336V28.6667H65.9389L77.3336 46.392V59.3334H70.6668V62H78.6668C79.4042 62 80.0001 61.4041 80.0001 60.6667V46C80.0003 45.7453 79.927 45.4933 79.7882 45.2788Z",
    fill: "#007F00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6666 43.3334V34.0001H69.3333V31.3334H57.3333C56.5959 31.3334 56 31.9307 56 32.6667V44.6667C56 45.404 56.5959 46 57.3333 46H77.3333V43.3332H58.6666V43.3334Z",
    fill: "#007F00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52 16.6669H1.33328C0.597344 16.6669 0 17.2642 0 18.0002V60.6669C0 61.4042 0.597344 62.0002 1.33328 62.0002H12V59.3334H2.66672V19.3334H50.6667V59.3334H25.3333V62.0002H52C52.7373 62.0002 53.3333 61.4042 53.3333 60.6669V18.0002C53.3333 17.2642 52.7373 16.6669 52 16.6669Z",
    fill: "#007F00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 54H1.33301V56.6667H9.33301V54Z",
    fill: "#007F00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6667 54H28V56.6667H50.6667V54Z",
    fill: "#007F00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6663 54H73.333V56.6667H78.6663V54Z",
    fill: "#007F00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0002 21.9999H5.3335V24.6666H52.0002V21.9999Z",
    fill: "#007F00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 59.3333H17.3335V62H20.0002V59.3333Z",
    fill: "#007F00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3337 59.3333H62.667V62H65.3337V59.3333Z",
    fill: "#007F00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 11.3334H5.3335V14.0001H24.0002V11.3334Z",
    fill: "#007F00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66672 11.3334H0V14.0001H2.66672V11.3334Z",
    fill: "#007F00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck1);
export default __webpack_public_path__ + "static/media/truck 1.86ce5543e47010121f81dc03089d257a.svg";
export { ForwardRef as ReactComponent };